require("@rails/activestorage").start();

import Collapse from "bootstrap/js/src/collapse";
import Alert from "bootstrap/js/src/alert";
import Modal from "bootstrap/js/src/modal";
import Dropdown from "bootstrap/js/src/dropdown";

void Collapse
void Alert

// Synchronous flag: home.js bundles a fallback dropdown implementation (added
// when this pack wasn't loaded on the home page) and would otherwise fight
// Bootstrap's Dropdown component — both listen on document for clicks on
// [data-bs-toggle="dropdown"] and toggle the .show class, causing flickering
// or stuck-open menus. Both scripts execute as deferred packs in document
// order BEFORE DOMContentLoaded fires, so setting this here guarantees
// home.js sees it when its bindDropdowns() runs from the DOMContentLoaded
// handler. If you ever change pack ordering in application.html.erb, verify
// importbootstrap still loads before DOMContentLoaded fires.
if (typeof window !== "undefined") {
  window.__devfoundBootstrapReady = true;
}

document.addEventListener("DOMContentLoaded", initializeDropdowns);
document.addEventListener("turbo:load", initializeDropdowns);

function initializeDropdowns() {
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach((dropdownTriggerEl) => {
    const instance = Dropdown.getInstance(dropdownTriggerEl);
    if (instance) {
      instance.dispose();
    }

    new Dropdown(dropdownTriggerEl);
  });
}

// Bootstrap's modal data-api — the document-level click listeners that open a
// modal from [data-bs-toggle="modal"] and close it from [data-bs-dismiss="modal"]
// — lives in the side-effectful tail of bootstrap/js/src/modal and gets
// tree-shaken out of the default-export import above (same reason dropdowns are
// re-wired by hand in initializeDropdowns). Without this, every
// data-bs-toggle="modal" trigger is a dead button — e.g. the "Sign Up Premium"
// modal (#staticBackdrop) would render in the DOM but never open. (The navbar's
// pricing modal used to rely on this too; it is now the /pricing page.) Re-register the data-api as delegated listeners on
// document so they survive Turbo navigations and dynamically-rendered modals.
// ESC + backdrop dismissal are handled by the Modal instance itself once shown,
// so only the toggle/dismiss clicks need wiring here.
document.addEventListener("click", (event) => {
  const trigger = event.target.closest('[data-bs-toggle="modal"]');
  if (trigger) {
    const selector = trigger.getAttribute("data-bs-target") || trigger.getAttribute("href");
    const target = selector && document.querySelector(selector);
    if (target) {
      event.preventDefault();
      Modal.getOrCreateInstance(target).show();
    }
    return;
  }

  const dismiss = event.target.closest('[data-bs-dismiss="modal"]');
  if (dismiss) {
    const modalEl = dismiss.closest(".modal");
    const instance = modalEl && Modal.getInstance(modalEl);
    if (instance) {
      instance.hide();
    }
  }
});
